import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { StudentTable } from './StudentTable';
import { ModalPortal } from '../../../ModalPortal';
import { addSection } from '../../../../Store/api/classApi';
import { CustomModal } from '../../../../shared/CustomModal';
import { classStudents } from '../../../../Store/api/professor/dashboard';
import './students.css';
import '../tabs.css';

const Students = ({ classId, classDetail = {}, setRefetch }) => {
  const dispatch = useDispatch();
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [refetch, setRefetchStudent] = useState(false);
  const [expandedSections, setExpandedSections] = useState([]);

  const [section, setSection] = useState({
    name: '',
    email: '',
    section_number: '',
  });

  useEffect(() => {
    dispatch(
      classStudents({
        id: classId,
        onSuccess: (res) => {
          const { data = [] } = res?.data || [];
          setIsLoading(false);
          setSections(data);
          if (data.length === 1) {
            expandSection(data[0]);
          }
        },
        onError: () => {
          setIsLoading(false);
        },
      })
    );
  }, [classId, dispatch, refetch, classId]);

  const expandSection = (i) => {
    if (expandedSections.includes(i)) {
      setExpandedSections((old) => old.filter((e) => e !== i));
    } else {
      setExpandedSections([i]);
      // setExpandedSections((old) => [...old, i]);
    }
  };

  const onToggle = () => setShowModal((prev) => !prev);
  const onAction = () => {
    if (!section.name) {
      toast.error('Section name required');
      return;
    } else if (!section.section_number) {
      toast.error('Section number required');
      return;
    } else if (!section.email) {
      toast.error('Instructor email required');
      return;
    }
    setLoading(true);
    dispatch(
      addSection({
        body: {
          classId,
          sectionName: section.name,
          instructorEmails: [section.email],
          sectionNumber: section.section_number,
        },
        onSuccess: () => {
          setRefetch(true);
          toast.success('Section added successfully.');
        },
        onError: () => {
          toast.error('Error while adding new section in class.');
        },
        onEnd: () => {
          setLoading(false);
          setSection({
            name: '',
            section_number: '',
            email: '',
          });
          setShowModal(false);
        },
      })
    );
  };

  const handleChange = (e) => {
    setSection((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  return (
    <>
      <ModalPortal>
        <CustomModal loading={loading} onHide={onToggle} onAction={onAction} showModal={showModal} cancelBtnText='Go back' actionBtnText='Add section' title='add new section to class'>
          <div className='d-flex flex-column gap-2 w-100'>
            <div className='d-flex justify-content-between'>
              <div className='form-group mb-0 w-47'>
                <input type='text' name='name' value={section.name} onChange={handleChange} className='form-control' placeholder='Section Name' />
                {/* {error.name && <span className="error-msg-3">*Section name required</span>} */}
              </div>
              <div className='form-group mb-0 w-47'>
                <input type='text' name='section_number' className='form-control' placeholder='Section Number' value={section.section_number} onChange={handleChange} />
                {/* {error.section_number && <span className="error-msg-3">*Section number required</span>} */}
              </div>
            </div>
            <div className='form-group mb-0 w-100'>
              <input type='email' name='email' value={section.email} onChange={handleChange} className='form-control mb-2' placeholder='Enter instructor email' />
              <p className='mb-0 text_grey fs-12 fw-normal lh-normal fst-normal'>*We’ll send the instructor an email inviting them to join Greyled</p>
            </div>
          </div>
        </CustomModal>
      </ModalPortal>
      <div className='tab-pane fade show active' id='Contents' role='tabpanel' aria-labelledby='Contents-tab'>
        <div className='Contents_tabs'>
          <div className='' id='myContents'>
            <div className='grade_table_wrapper students' style={{ scrollbarWidth: 'none' }}>
              <table className='students_talbe'>
                <tr className='std_table_header'>
                  <th>Student Name (Pronouns)</th>
                  <th>Email address</th>
                  <th colSpan={5}>Last Submission</th>
                </tr>
                <StudentTable
                  {...{
                    isLoading,
                    sections,
                    expandedSections,
                    expandSection,
                    classDetail,
                    setRefetchStudent,
                  }}
                />
                {!isLoading && !sections.length && (
                  <tbody>
                    <tr className='header_row'>
                      <td className='py-20'>
                        <p className='d-flex justify-content-start align-items-center gap-1 m-0 text-uppercase fw-700'>
                          <span className='text-purple cursor text-decoration-underline' onClick={onToggle}>
                            Add Section
                          </span>
                          To Class
                        </p>
                      </td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                )}
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Students;
